module.exports = __webpack_public_path__ + "static/icon-6726b71fb5e80802e4f9306b82c1e9bf.png";